import script from "./Excel.vue?vue&type=script&setup=true&lang=js"
export * from "./Excel.vue?vue&type=script&setup=true&lang=js"

import "./Excel.vue?vue&type=style&index=0&id=7ed048dc&lang=scss&scoped=true"
import "./Excel.vue?vue&type=style&index=1&id=7ed048dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed048dc"]])

export default __exports__